import React, {FC} from 'react';
import {cx} from './cx';

interface AvatarProps {
  src?: string;
  name: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const initials = (name: string) =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join('');

export const Avatar: FC<AvatarProps> = ({
  src,
  name,
  size = 'md',
  className,
}) => (
  <span
    aria-label={name}
    className={cx('sui-avatar', `sui-avatar--${size}`, className)}
    role="img"
    title={name}
  >
    {src ? <img alt="" src={src} /> : <span>{initials(name)}</span>}
  </span>
);

export interface AvatarItem {
  src?: string;
  name: string;
}

interface AvatarStackProps {
  avatars: AvatarItem[];
  max?: number;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

export const AvatarStack: FC<AvatarStackProps> = ({
  avatars,
  max = 4,
  size = 'sm',
  className,
}) => {
  const visible = avatars.slice(0, max);
  const remaining = Math.max(avatars.length - visible.length, 0);

  return (
    <span
      aria-label={avatars.map(avatar => avatar.name).join(', ')}
      className={cx('sui-avatar-stack', className)}
    >
      {visible.map((avatar, index) => (
        <Avatar
          key={`${avatar.name}-${index}`}
          name={avatar.name}
          size={size}
          src={avatar.src}
        />
      ))}
      {remaining > 0 && (
        <span className={cx('sui-avatar', `sui-avatar--${size}`)}>
          +{remaining}
        </span>
      )}
    </span>
  );
};
